import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';

import { IFormState, TElement } from '../types/calculator';
import { DEFAULT_FORM_STATE } from '../constants/defaultFormState';
import { useCalculatorCustomEvents } from './useCalculatorCustomEvents';
import { selectDefaultFormState } from '../selectors';

export const useCalculatorForm = (formScheme: TElement[], formRef: HTMLFormElement | null) => {
  const preselectedFormValues = useSelector(selectDefaultFormState);
  const reactHookForm = useForm<IFormState>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: { ...DEFAULT_FORM_STATE, ...preselectedFormValues },
  });

  const { formState, watch, trigger } = reactHookForm;
  const formValues = watch();

  const validateOnBlurHandler = useCallback(async () => {
    if (formState.isValid) {
      return;
    }
    await trigger(['downPayment', 'objectCost', 'loanTerm']);
  }, [formState.isValid, trigger]);

  useCalculatorCustomEvents({ formValues, formState, eventTarget: formRef, formScheme });

  return { reactHookForm, validateOnBlurHandler };
};
